// WebView2 하이브리드 통신 클래스
export class Hybrid {
  constructor() {
    this.isListening = false;
    this.messageListener = null;
    this.pendingResponses = new Map();
    this.callbacks = [];
    this.requestId = 1;
    this.onReadyCallback = null;
  }

  setOnReady(callback) {
    this.onReadyCallback = callback;
  }

  listenToWebView() {
    if (!window.chrome?.webview) {
      console.warn("❌ WebView2가 감지되지 않습니다. Hybrid 기능을 사용할 수 없습니다.");
      return false;
    }
    if (this.isListening) return false;

    this.messageListener = (event) => {
      try {
        const raw = event.data;
        const data = typeof raw === "string" ? JSON.parse(raw) : raw;

        if (data?.id && this.pendingResponses.has(data.id)) {
          const callback = this.pendingResponses.get(data.id);
          if (callback) callback(data);
          this.pendingResponses.delete(data.id);
          console.log("ID 수신");
        } else {
          this.callbacks.forEach(cb => cb(data)); // 단방향 통신
        }
      } catch (err) {
        console.error("❌ WebView 메시지 파싱 오류:", event.data);
      }
    };

    window.chrome.webview.addEventListener("message", this.messageListener);
    this.isListening = true;
    console.log("✅ WebView 메시지 리스너 최초 등록 완료", this);
    return true;
  }

  pushOnMessageCallback(cb) {
    this.callbacks.push(cb);
  }

  offMessage() {
    console.log(this.isListening, window.chrome?.webview, this.messageListener);
    if (this.isListening && window.chrome?.webview && this.messageListener) {
      console.log("🔄 메시지 리스너 제거");
      window.chrome.webview.removeEventListener("message", this.messageListener);
      this.isListening = false;
      this.messageListener = null;
    }
  }

  send(cmd, msg, param = {}, timeout = 5000) {
    return new Promise((resolve, reject) => {
      const id = this.requestId++;
      const payload = JSON.stringify({ cmd, msg, param, id });
      const timer = setTimeout(() => {
        console.warn("⏱ 응답 타임아웃:", id);
        this.pendingResponses.delete(id);
        reject(new Error("Request timed out"));
      }, timeout);

      this.pendingResponses.set(id, (data) => {
        clearTimeout(timer);
        if (data && data.status !== "success") {
          reject(new Error(`Error in response: ${data.status}`));
          return;
        }
        resolve(data);
      });

      if (window.chrome && window.chrome.webview) {
        console.log("🌐 web => app (전송):", msg);
        window.chrome.webview.postMessage(payload);
      } else {
        console.log("❌ WebView2가 감지되지 않습니다. Hybrid 기능을 사용할 수 없습니다.");
      }
    });
  }

  isWebViewAvailable() {
    return !!(window.chrome?.webview);
  }

  // WebView2 연결 테스트
  async testConnection() {
    try {
      if (!this.isWebViewAvailable()) {
        console.warn("❌ WebView2를 사용할 수 없습니다.");
        return false;
      }

      console.log("🔍 WebView2 연결 테스트 중...");
      const result = await this.send("test", "ping", {}, 3000);
      console.log("✅ WebView2 연결 테스트 성공:", result);
      return true;
    } catch (error) {
      console.error("❌ WebView2 연결 테스트 실패:", error);
      return false;
    }
  }
}
